// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
    width: 100%;
    table-layout: fixed
}
.wrapper{
    /* background :url('/assets/Images/background.png'); */
    /*height:90vh;
    width:100vw;
    overflow: hidden;
    background-repeat: no-repeat;*/
    background-size: 100%;
    padding-top: 9vh;
}
.card {
    transition: .3s;
    width: 50%;
    top: 100px;
    /* position: relative; */
    display: inline-block;
    /* margin: 19px; */
    color:#fff;
    transition: transform .25s ease
}
.raisepermit{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);
    border-radius:50%;
    outline :none;
}
.raisepermit:hover{ 
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .8);
    transform: scale(1);
    cursor: pointer;
    border:none !important;
}

#trends{
    background: url('/assets/Images/Group326.png');
    background-size: 100% 100%;
    height: 258px;
    width: 261px;
    margin-top: 25%;
}
#permitmgmt{
    background: url('/assets/Images/Group265.png');
    background-size: 100% 100%;
    height: 258px;
    width: 261px;
    margin-top:25%;
    /* left: -133px; */
}
#raisePermit{
    background: url('/assets/Images/Group352@2x.png');
    background-size: 100% 100%;
    height: 258px;
    width: 261px;
    margin-top:25%;
    /* left: -88px; */
}

#trends:hover{
    background: url('/assets/Images/Group351.png');
}
#permitmgmt:hover{
    background: url('/assets/Images/Group350.png');
}
#raisePermit:hover{
    background: url('/assets/Images/Group353.png');
}
.card:hover{
    color:#000 !important;
}
/* .card:hover{
    color:#000 !important;
}
.card:hover{
    color:#000 !important;
} */
 /* .layoutFont:hover .layoutFont{
    color:#000 !important;
}
 .layoutFont:hover.layoutFont{
    color:#000 !important;
}
 .layoutFont:hover.layoutFont{
    color:#000 !important;
} */

.cardHeader {
    height: 350px;
    background-image: linear-gradient(dimgrey, grey, #a9a9a9);
    border-radius: 10px 10px 0 0;
    text-align: center;
    vertical-align: center
}

.cardBody {
    padding: 5px;
    background-color: #003658;
    position: absolute;
    color: #fff;
    width: 100%;
    border-radius: 0 0 10px 10px;
    height: 83px;
    text-align: center;
    font-size: 19px
}

.cardBody div {
    margin-top: 23px;
    font-weight: 700
}

.cardIcon {
    font-size: 12em;
    color: #fff;
    position: relative;
    top: 80px;
}

.cardFooter {
    background-color: #165788;
    color: #fff;
    margin-top: 15px;
    height: 195px;
    border-radius: 0 0 10px 10px
}

.cardFooter a {
    color: #fff
}

.clsNotificationCount {
    background-color: red;
    border-radius: 50%;
    padding: 5px 12px;
    position: relative;
    font-weight: 700;
    font-size: 22px;
    color: #fff;
    top: -19px;
    left: 27px
}

:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788!important;
    border-radius: 3px;
    background: #f4f4f4!important;
    box-shadow: 3px 3px 12px #165788
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0!important
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #fff!important
}

.toast-header {
    background-color: #165788;
    color: #fff;
    padding: 1px 1px 1px 10px!important
}

:host ::ng-deep .ui-multiselect {
    min-width: 80% !important;
    max-width: 80% !important;
}

.layout-font {
    font-size: 15px !important;
    padding: 0px 0px !important;
    font-weight: bold !important;
    width: 100%;
    border-radius: 0 0 10px 10px;
    text-align: center;
    top: 61%;
    position: relative;
}
.setcontent{
    width:80% !important;
    margin:auto;
    padding-top:10%;
}
 /* For portrait layouts only */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {
    .setcontent{
        width: 100% !important;
        margin: auto;
        padding-top: 10%;
        background: 100% 100%;
    }
    .card{
        position: inherit;
    }
    .layout-font{
        font-size: 15px !important;
        padding: 0px 0px !important;
        font-weight: bold !important;
        width: 100%;
        border-radius: 0 0 10px 10px;
        text-align: center;
    } 
    
    #raisePermit {
        background: url('/assets/Images/Group352@2x.png');
        background-size: 100% 100%;
        height: 200px;
        width: 200px;
        top: 160px !important;
        position: relative;
    
      
        

  }
  #permitmgmt {
    background: url('/assets/Images/Group265.png');
    background-size: 100% 100%;
    height: 200px;
    width:  200px;
    top: 160px !important;
    position: relative;
 
}
#trends {
    background: url('/assets/Images/Group326.png');
    background-size: 100% 100%;
    height: 200px;
    width:  200px;
    top: 160px !important;
    position: relative;
   
 
}
#trends:hover{
    background: url('/assets/Images/Group351.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;
}
#permitmgmt:hover{
    background: url('/assets/Images/Group350.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;
}
#raisePermit:hover{
    background: url('/assets/Images/Group353.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;
}
.card:hover{
    color:#000 !important;
}

}
 /* For landscape layouts only */
/* @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {
   
   
  } */
 /* For landscape layouts only */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {
    .card{
        position: inherit;
    }
    .layout-font{
        font-size: 15px !important;
        padding: 0px 0px !important;
        font-weight: bold !important;
        width: 100%;
        border-radius: 0 0 10px 10px;
        text-align: center;
    }     
    
    #raisePermit {
        background: url('/assets/Images/Group352@2x.png');
        background-size: 100% 100%;
        height: 200px;
        width: 200px;;
        top: 100px !important;
        position: relative;
        /* left: 84px; */
  }
  #permitmgmt {
    background: url('/assets/Images/Group265.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;
    top: 100px !important;
    position: relative;
    /* left: -70px !important; */
}
#trends {
    background: url('/assets/Images/Group326.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;;
    top: 100px !important;
    position: relative;
    /* right: 223px !important; */
}
 

#trends:hover{
    background: url('/assets/Images/Group351.png');
    background-size: 100% 100%;
    height: 200px;
    width:  200px;;
}
#permitmgmt:hover{
    background: url('/assets/Images/Group350.png');
    background-size: 100% 100%;
    height: 200px;
    width:  200px;;
}
#raisePermit:hover{
    background: url('/assets/Images/Group353.png');
    background-size: 100% 100%;
    height: 200px;
    width: 200px;;
}
.card:hover{
    color:#000 !important;
}

}

.container {
    background-color: #ffff;
    position: relative;
    margin: 0;
    /* padding: 5px 10px 24px;5px 15px 0px 10px */
    /* padding: 5px 15px 0px 10px; */
}`, "",{"version":3,"sources":["webpack://./src/app/layout/layout.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX;AACJ;AACA;IACI,sDAAsD;IACtD;;;kCAG8B;IAC9B,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;IACV,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV;AACJ;AACA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,iDAAiD;IACjD,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,8CAA8C;AAClD;AACA;IACI,8CAA8C;AAClD;AACA;IACI,8CAA8C;AAClD;AACA;IACI,qBAAqB;AACzB;AACA;;;;;GAKG;CACF;;;;;;;;GAQE;;AAEH;IACI,aAAa;IACb,yDAAyD;IACzD,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,6BAA6B;IAG7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,WAAW;IACX,eAAe;AACnB;CACC,8BAA8B;AAC/B;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,WAAW;QACX,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,iDAAiD;QACjD,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;;;;;EAKxB;EACA;IACE,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,kBAAkB;;AAEtB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,kBAAkB;;;AAGtB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;AAChB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;AAChB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA;CACC,+BAA+B;AAChC;;;KAGK;CACJ,+BAA+B;AAChC;IACI;QACI,iBAAiB;IACrB;IACA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,4BAA4B;QAC5B,WAAW;QACX,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,iDAAiD;QACjD,0BAA0B;QAC1B,aAAa;QACb,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,gBAAgB;EACtB;EACA;IACE,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;AACjC;;;AAGA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;;AAEA;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,6CAA6C;IAC7C,gCAAgC;AACpC","sourcesContent":["table {\r\n    width: 100%;\r\n    table-layout: fixed\r\n}\r\n.wrapper{\r\n    /* background :url('/assets/Images/background.png'); */\r\n    /*height:90vh;\r\n    width:100vw;\r\n    overflow: hidden;\r\n    background-repeat: no-repeat;*/\r\n    background-size: 100%;\r\n    padding-top: 9vh;\r\n}\r\n.card {\r\n    transition: .3s;\r\n    width: 50%;\r\n    top: 100px;\r\n    /* position: relative; */\r\n    display: inline-block;\r\n    /* margin: 19px; */\r\n    color:#fff;\r\n    transition: transform .25s ease\r\n}\r\n.raisepermit{\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);\r\n    border-radius:50%;\r\n    outline :none;\r\n}\r\n.raisepermit:hover{ \r\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .8);\r\n    transform: scale(1);\r\n    cursor: pointer;\r\n    border:none !important;\r\n}\r\n\r\n#trends{\r\n    background: url('/assets/Images/Group326.png');\r\n    background-size: 100% 100%;\r\n    height: 258px;\r\n    width: 261px;\r\n    margin-top: 25%;\r\n}\r\n#permitmgmt{\r\n    background: url('/assets/Images/Group265.png');\r\n    background-size: 100% 100%;\r\n    height: 258px;\r\n    width: 261px;\r\n    margin-top:25%;\r\n    /* left: -133px; */\r\n}\r\n#raisePermit{\r\n    background: url('/assets/Images/Group352@2x.png');\r\n    background-size: 100% 100%;\r\n    height: 258px;\r\n    width: 261px;\r\n    margin-top:25%;\r\n    /* left: -88px; */\r\n}\r\n\r\n#trends:hover{\r\n    background: url('/assets/Images/Group351.png');\r\n}\r\n#permitmgmt:hover{\r\n    background: url('/assets/Images/Group350.png');\r\n}\r\n#raisePermit:hover{\r\n    background: url('/assets/Images/Group353.png');\r\n}\r\n.card:hover{\r\n    color:#000 !important;\r\n}\r\n/* .card:hover{\r\n    color:#000 !important;\r\n}\r\n.card:hover{\r\n    color:#000 !important;\r\n} */\r\n /* .layoutFont:hover .layoutFont{\r\n    color:#000 !important;\r\n}\r\n .layoutFont:hover.layoutFont{\r\n    color:#000 !important;\r\n}\r\n .layoutFont:hover.layoutFont{\r\n    color:#000 !important;\r\n} */\r\n\r\n.cardHeader {\r\n    height: 350px;\r\n    background-image: linear-gradient(dimgrey, grey, #a9a9a9);\r\n    border-radius: 10px 10px 0 0;\r\n    text-align: center;\r\n    vertical-align: center\r\n}\r\n\r\n.cardBody {\r\n    padding: 5px;\r\n    background-color: #003658;\r\n    position: absolute;\r\n    color: #fff;\r\n    width: 100%;\r\n    border-radius: 0 0 10px 10px;\r\n    height: 83px;\r\n    text-align: center;\r\n    font-size: 19px\r\n}\r\n\r\n.cardBody div {\r\n    margin-top: 23px;\r\n    font-weight: 700\r\n}\r\n\r\n.cardIcon {\r\n    font-size: 12em;\r\n    color: #fff;\r\n    position: relative;\r\n    top: 80px;\r\n}\r\n\r\n.cardFooter {\r\n    background-color: #165788;\r\n    color: #fff;\r\n    margin-top: 15px;\r\n    height: 195px;\r\n    border-radius: 0 0 10px 10px\r\n}\r\n\r\n.cardFooter a {\r\n    color: #fff\r\n}\r\n\r\n.clsNotificationCount {\r\n    background-color: red;\r\n    border-radius: 50%;\r\n    padding: 5px 12px;\r\n    position: relative;\r\n    font-weight: 700;\r\n    font-size: 22px;\r\n    color: #fff;\r\n    top: -19px;\r\n    left: 27px\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788!important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4!important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0!important\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #fff!important\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #fff;\r\n    padding: 1px 1px 1px 10px!important\r\n}\r\n\r\n:host ::ng-deep .ui-multiselect {\r\n    min-width: 80% !important;\r\n    max-width: 80% !important;\r\n}\r\n\r\n.layout-font {\r\n    font-size: 15px !important;\r\n    padding: 0px 0px !important;\r\n    font-weight: bold !important;\r\n    width: 100%;\r\n    border-radius: 0 0 10px 10px;\r\n    text-align: center;\r\n    top: 61%;\r\n    position: relative;\r\n}\r\n.setcontent{\r\n    width:80% !important;\r\n    margin:auto;\r\n    padding-top:10%;\r\n}\r\n /* For portrait layouts only */\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {\r\n    .setcontent{\r\n        width: 100% !important;\r\n        margin: auto;\r\n        padding-top: 10%;\r\n        background: 100% 100%;\r\n    }\r\n    .card{\r\n        position: inherit;\r\n    }\r\n    .layout-font{\r\n        font-size: 15px !important;\r\n        padding: 0px 0px !important;\r\n        font-weight: bold !important;\r\n        width: 100%;\r\n        border-radius: 0 0 10px 10px;\r\n        text-align: center;\r\n    } \r\n    \r\n    #raisePermit {\r\n        background: url('/assets/Images/Group352@2x.png');\r\n        background-size: 100% 100%;\r\n        height: 200px;\r\n        width: 200px;\r\n        top: 160px !important;\r\n        position: relative;\r\n    \r\n      \r\n        \r\n\r\n  }\r\n  #permitmgmt {\r\n    background: url('/assets/Images/Group265.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width:  200px;\r\n    top: 160px !important;\r\n    position: relative;\r\n \r\n}\r\n#trends {\r\n    background: url('/assets/Images/Group326.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width:  200px;\r\n    top: 160px !important;\r\n    position: relative;\r\n   \r\n \r\n}\r\n#trends:hover{\r\n    background: url('/assets/Images/Group351.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;\r\n}\r\n#permitmgmt:hover{\r\n    background: url('/assets/Images/Group350.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;\r\n}\r\n#raisePermit:hover{\r\n    background: url('/assets/Images/Group353.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;\r\n}\r\n.card:hover{\r\n    color:#000 !important;\r\n}\r\n\r\n}\r\n /* For landscape layouts only */\r\n/* @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\r\n   \r\n   \r\n  } */\r\n /* For landscape layouts only */\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\r\n    .card{\r\n        position: inherit;\r\n    }\r\n    .layout-font{\r\n        font-size: 15px !important;\r\n        padding: 0px 0px !important;\r\n        font-weight: bold !important;\r\n        width: 100%;\r\n        border-radius: 0 0 10px 10px;\r\n        text-align: center;\r\n    }     \r\n    \r\n    #raisePermit {\r\n        background: url('/assets/Images/Group352@2x.png');\r\n        background-size: 100% 100%;\r\n        height: 200px;\r\n        width: 200px;;\r\n        top: 100px !important;\r\n        position: relative;\r\n        /* left: 84px; */\r\n  }\r\n  #permitmgmt {\r\n    background: url('/assets/Images/Group265.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;\r\n    top: 100px !important;\r\n    position: relative;\r\n    /* left: -70px !important; */\r\n}\r\n#trends {\r\n    background: url('/assets/Images/Group326.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;;\r\n    top: 100px !important;\r\n    position: relative;\r\n    /* right: 223px !important; */\r\n}\r\n \r\n\r\n#trends:hover{\r\n    background: url('/assets/Images/Group351.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width:  200px;;\r\n}\r\n#permitmgmt:hover{\r\n    background: url('/assets/Images/Group350.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width:  200px;;\r\n}\r\n#raisePermit:hover{\r\n    background: url('/assets/Images/Group353.png');\r\n    background-size: 100% 100%;\r\n    height: 200px;\r\n    width: 200px;;\r\n}\r\n.card:hover{\r\n    color:#000 !important;\r\n}\r\n\r\n}\r\n\r\n.container {\r\n    background-color: #ffff;\r\n    position: relative;\r\n    margin: 0;\r\n    /* padding: 5px 10px 24px;5px 15px 0px 10px */\r\n    /* padding: 5px 15px 0px 10px; */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
